import styled from 'styled-components';
export var ActionBubble = styled.div.withConfig({
  displayName: "partials__ActionBubble",
  componentId: "sc-1nmcayd-0"
})(["position:relative;width:", ";height:", ";svg{position:absolute;top:14px;left:0;right:0;width:", ";height:", ";margin-left:auto;margin-right:auto;color:", ";text-align:center;&:first-child{top:0;width:", ";height:", ";}}"], function (_ref) {
  var size = _ref.size;
  return size.bubble;
}, function (_ref2) {
  var size = _ref2.size;
  return size.bubble;
}, function (_ref3) {
  var size = _ref3.size;
  return size.icon;
}, function (_ref4) {
  var size = _ref4.size;
  return size.icon;
}, function (_ref5) {
  var theme = _ref5.theme,
    color = _ref5.color;
  return theme.colors[color];
}, function (_ref6) {
  var size = _ref6.size;
  return size.bubble;
}, function (_ref7) {
  var size = _ref7.size;
  return size.bubble;
});
export var ActionIconBlock = styled.div.withConfig({
  displayName: "partials__ActionIconBlock",
  componentId: "sc-1nmcayd-1"
})(["display:flex;justify-content:center;margin-bottom:9px;margin-left:auto;margin-right:auto;"]);